
export const APP_VERSION = '1.0.4';
export const APP_VERSION_DEV = '1.0.2';
export const BUILD_DATE = '26-05-2026 15:40:08';
export const BUILD_NUMBER = '260520261540';
